var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-empty"},[_c('el-load-icon',{staticClass:"el-load-icon"}),_c('span',{staticClass:"empty-text"},[_vm._t("default",[_vm._v("暂无数据")])],2),_c('el-load-icon',{staticClass:"el-load-icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }